module.exports = __webpack_public_path__ + "img/sparkiez_logo.5d232c1c.svg";